import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./EducationCarousel.css";

function EducationCarousel() {
    const education = [
        {
            title: "Master of Social Work (MSW)",
            university: "York University",
            year: "2021 – 2023",
            image: "/york.jpg"
        },
        {
            title: "PhD Candidate",
            university: "Capella University",
            year: "2025 – Present",
            image: "/capella_university_logo.jpg"

        },
        {
            title: "Bachelor of Social Work (BSW)",
            university: "York University",
            year: "2019 – 2021",
            image: "/york.jpg"

        }
    ];

    return (
        <div className="edu-carousel-container">
            <h2 className="edu-title">Education & Academic Background</h2>

            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                navigation
                loop
                spaceBetween={40}
                slidesPerView={1}
                className="edu-swiper"
            >
                {education.map((item, index) => (
                    <SwiperSlide key={index} className="edu-slide">

                        {/* نمایش عکس دانشگاه */}
                        {item.image && (
                            <img
                                src={item.image}
                                alt={item.university}
                                className="edu-img"
                            />
                        )}

                        <h3>{item.title}</h3>
                        <p>{item.university}</p>
                        <span>{item.year}</span>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default EducationCarousel;
